<template>
    <div class="submit-spc-order">
        <el-form ref="form" label-width="100px" label-position="left">
            <div class="form-title mt10">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                客户信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">合同类型：</div>
                        <div class="content">{{ Orders_Type == 0 ? '销售合同' : Customer_info.Orders_Type == 1 ? '服务合同' : '' }}</div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="resultInfoApply_SN">
                            <div class="label">报价单编号：</div>
                            <div class="content">{{ resultInfoApply_SN }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="PipelineCustomer.ID">
                            <div class="label">商机编号：</div>
                            <div class="content">{{ PipelineCustomer.ID + ' [' + PipelineCustomer.opportunityName + ']' }}</div>
                        </div>
                    </div>
                    <div class="flex" v-if="Customer_info.Customer_Type == '0'">
                        <div class="info-item">
                            <div class="label">客户编号：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Code }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">客户名称：</div>
                            <div class="content">{{ Customer_info.Customer_Name }}</div>
                        </div>
                    </div>
                    <div class="flex" v-else>
                        <div class="info-item">
                            <div class="label">客户姓名：</div>
                            <div class="content label-middle">{{ Customer_info.Person_Name }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">客户手机：</div>
                            <div class="content">{{ Customer_info.Person_Mobile }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">客户类型：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Type == '0' ? '企业客户' : '个人客户' }}</div>
                        </div>
                        <div class="info-item" v-if="Customer_info.Customer_Type == 0">
                            <div class="label">注册所在地：</div>
                            <div class="content">{{ Customer_info.Customer_RegAddr }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">付款方式：</div>
                        <div class="content">{{ submitpaymentObj.value }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title mt10" v-if="TradeType == 1">纸质合同编号</div>
            <el-form-item :label="PaperContractSNPlace" label-width="110px" v-if="TradeType == 1">
                <el-input class="el-select-big" v-model="params.Orders_PaperContractSN" placeholder="请输入纸质合同编号"></el-input>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                工程信息
            </div>
            <el-form-item label="工程区域" v-if="resultInfoApply_SN">
                {{ ProjectTypeRecursion }}
            </el-form-item>
            <el-form-item label="工程区域" v-else>
                <el-select v-model="params.Customer_Project_Country" placeholder="请选择国家" class="el-select-medium" @change="countryChange(1, $event)" clearable filterable>
                    <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN" :value="item.Country_Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_State" placeholder="省/直辖市" @change="provinceChange" clearable filterable>
                    <el-option v-for="item in provinceList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_City" placeholder="市" @change="cityChange" clearable filterable>
                    <el-option v-for="item in cityListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_County" placeholder="区/县" clearable filterable>
                    <el-option v-for="item in districtListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>

                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <el-form-item label="工程名称">
                <el-input class="el-select-medium"  autocomplete="on" name="Customer_Project_PreName"  v-model="params.Customer_Project_NameThree" maxlength="5" placeholder="工程名称前缀，选填"></el-input>
                <el-input class="el-select-medium ml10"  autocomplete="on" name="Customer_Project_Name"  v-model="params.Customer_Project_Name" maxlength="40" placeholder="主体工程名称，必填"></el-input>
                <el-input class="el-select-medium ml10" autocomplete="on" name="Customer_Project_LastName"  v-model="params.Customer_Project_NameTwo" maxlength="5" placeholder="工程名称后缀，选填"></el-input>
                <span v-if="!resultInfoApply_SN">
                    <el-select class="el-select-medium ml10" :value="isValidProjectType ? params.Orders_ProjectType_ID : ''" @input="handleProjectTypeChange" placeholder="请选择行业分类" @change="getProjectTypes({ name: 'two', id: params.Orders_ProjectType_ID })">
                        <el-option v-for="item in ProjectTypesList" :key="item.Project_Type_ID" :label="item.Project_Type_Name" :value="item.Project_Type_ID">
                            <span style="float: left">{{ item.Project_Type_Name }}</span>
                        </el-option>
                    </el-select>
                    <el-select class="el-select-medium ml10" v-if="ProjectTypesListTwo.length" v-model="params.Orders_ProjectType_ID_Two" placeholder="请选择行业分类" @change="getProjectTypes({ name: 'three', id: params.Orders_ProjectType_ID_Two })">
                        <el-option v-for="item in ProjectTypesListTwo" :key="item.Project_Type_ID" :label="item.Project_Type_Name" :value="item.Project_Type_ID">
                            <span style="float: left">{{ item.Project_Type_Name }}</span>
                        </el-option>
                    </el-select>
                    <el-select class="el-select-medium ml10" v-if="ProjectTypesListThree.length" v-model="params.Orders_ProjectType_ID_Three" placeholder="请选择行业分类">
                        <el-option v-for="item in ProjectTypesListThree" :key="item.Project_Type_ID" :label="item.Project_Type_Name" :value="item.Project_Type_ID">
                            <span style="float: left">{{ item.Project_Type_Name }}</span>
                        </el-option>
                    </el-select>
                </span>

                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                合同联系人
            </div>
            <!-- 根据付款方式和客户信息条件渲染联系人表单 -->
            <div v-if="submitpaymentObj.id < 3 || submitpaymentObj.id == 7 || (SearchUserCustomerInfo.Customer_AgingCode == '' || new Date(SearchUserCustomerInfo.Customer_PaymentExpiredDate) < new Date())">
                <!-- 联系人姓名 -->
                <el-form-item label="联系人姓名" v-if="Customer_info.Customer_SubID == 0 && Customer_info.Customer_Type == 0">
                    <el-input class="el-select-big" autocomplete="on" name="Orders_Contract_Name" v-model="params.Orders_Contract_Name" :disabled="Customer_info.Customer_SubID != ''">
                        <el-button slot="append" icon="el-icon-search" @click="searchUser" v-if="Customer_info.Customer_SubID == ''"></el-button>
                    </el-input>
                    <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
                <el-form-item label="联系人姓名" v-else>
                        {{ params.Orders_Contract_Name }}
                        <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
                
                <!-- 联系人手机 -->
                <el-form-item label="联系人手机" v-if="Customer_info.Customer_Type == 0">
                    <el-input class="el-select-big" autocomplete="on" name="Orders_Contract_Mobile" v-model="params.Orders_Contract_Mobile" type="tel"></el-input>
                    <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
                <el-form-item label="联系人手机" v-else>
                        {{ params.Orders_Contract_Mobile }}
                        <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
                
                <!-- 联系人邮箱 -->
                <el-form-item label="联系人邮箱">
                    <el-input class="el-select-big" autocomplete="on" name="Orders_Contract_Email" v-model="params.Orders_Contract_Email" placeholder="联系人邮箱,必填"></el-input>
                    <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
            </div>
            
            <!-- 选择器模式 -->
            <div v-else>
                <el-form-item label="联系人姓名">
                    <el-select class="el-select-big" v-model="selectedContactName" placeholder="请选择联系人" @change="handleContactChange">
                        <el-option 
                            v-for="item in SearchUserCustomerInfo_list" 
                            :key="item.name" 
                            :label="item.name" 
                            :value="item.name">
                        </el-option>
                    </el-select>
                    <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
                <el-form-item label="联系人手机">
                    <el-input class="el-select-big" v-model="selectedContactMobile" type="tel" disabled></el-input>
                    <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
                <el-form-item label="联系人邮箱">
                    <el-input class="el-select-big" v-model="selectedContactEmail" disabled></el-input>
                    <font style="color: #ff0000; margin-left: 5px">*</font>
                </el-form-item>
            </div>
            <el-form-item label="短信通知">
                <el-checkbox-group v-model="params.informValur">
                    <el-checkbox :label="1" value="1">客户</el-checkbox>
                    <el-checkbox :label="2" value="2">业务员</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <div class="form-title" v-show="IsHonly == 0">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                配送方式
            </div>
            <el-form-item label="配送方式" v-show="IsHonly == 0">
                <el-radio-group v-model="params.Orders_Delivery_ID">
                    <el-radio :label="4">供方指定</el-radio>
                    <el-radio :label="1">
                        <span>自提</span>
                        <span class="tip">提货前请联系中转库是否满足提货条件</span>
                    </el-radio>
                    <el-radio :label="2">
                        <span>其他</span>
                        <el-input class="ml10" type="text" v-model="params.delivery_name" placeholder="请输入配送方式"></el-input>
                        <span class="tip">到付运费</span>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                配送信息
            </div>
            <el-form-item label="配送地址">
                <div v-if="isReturnGoods != 1 && Orders_SourceCate != 1 && applyInfo && Object.keys(applyInfo).length">
                    <el-select v-if="historicalAddressList && historicalAddressList.length" class="el-select-medium mb10" style="width: 500px" v-model="historicalAddress" placeholder="项目历史地址" @change="historicalPickConfirm" clearable filterable>
                        <el-option v-for="item in historicalAddressList" :key="item.ShowMessage" :label="item.ShowMessage" :value="item.ShowMessage"></el-option>
                    </el-select>
                    <span class="tip" v-if="historicalAddressList && historicalAddressList.length">项目历史地址</span>
                    <span class="tip" v-else>暂无项目历史地址</span>
                    <br/>
                </div>
                <el-select v-model="params.Orders_Address_Country" placeholder="请选择国家" class="el-select-medium" clearable filterable @change="countryChange(2, $event)">
                    <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN" :value="item.Country_Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Orders_Address_State" placeholder="省/直辖市" @change="provinceChangeAddress" clearable filterable>
                    <el-option v-for="item in siteprovinceList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Orders_Address_City" placeholder="市" @change="cityChangeAddress" clearable filterable>
                    <el-option v-for="item in cityListAddress" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Orders_Address_County" placeholder="区/县" clearable filterable>
                    <el-option v-for="item in districtListAddress" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <font style="color: #ff0000; margin-left: 5px">*</font>
                <br />
                <el-input class="el-select-big" autocomplete="on" name="Orders_Address_StreetAddress" v-model="params.Orders_Address_StreetAddress" placeholder="收货地址"></el-input>
                <el-input class="el-select-mini ml10"  autocomplete="on"  name="Orders_Address_Zip" v-model="params.Orders_Address_Zip" placeholder="邮编"></el-input>
                <el-select class="el-select-medium ml10" v-model="params.Orders_Address_StreetAddress_type">
                    <el-option label="客户地址" value="Y"></el-option>
                    <el-option label="办事处地址" value="N"></el-option>
                </el-select>
                <font style="color: #ff0000; margin-left: 5px">*</font>
                <br />
            </el-form-item>
            <el-form-item label="收货人">
                <el-input class="el-select-medium" autocomplete="on" name="Orders_Address_Name" v-model="params.Orders_Address_Name" placeholder="收货人姓名"></el-input>
                <font style="color: #ff0000; margin-left: 5px">*</font>
                <el-input class="el-select-medium ml10" autocomplete="on" name="Orders_Address_Phone_Number" v-model="params.Orders_Address_Phone_Number" placeholder="联系电话，多个手机之间以“;”号分隔"></el-input>
                <el-input class="el-select-medium ml10" autocomplete="on" name="Orders_Address_Mobile" v-model="params.Orders_Address_Mobile" placeholder="手机,  多个手机之间以“;”号分隔"></el-input>
                <span class="tip">联系电话任选其一</span>
            </el-form-item>
            <el-form-item label="业务员" v-if="Orders_SourceCate != 1 && Orders_Type == 0">
                <el-select class="el-select-medium" v-model="params.Orders_OfficeManID" @change="publicSelectChange('office', $event)">
                    <el-option v-for="item in offinceList" :key="item.ID" :label="item.OwnerName" :value="item.ID"></el-option>
                </el-select>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                配电柜厂家
            </div>
            <el-form-item label="配电柜厂家">
                <el-select v-model="params.CabinetSupplier" class="el-select-big" filterable placeholder="货发配电柜厂家名称搜索" @change="publicSelectChange('cabinet', $event)">
                    <el-option v-for="item in SupplierList" :key="item.value" :label="item.Name" :value="item.value"></el-option>
                </el-select>
                <span class="tip">
                    使用选择配电柜厂家地址作为收货地址，
                    <span style="color: #ff3040">仅当选择“即时发货”时适用</span>
                </span>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                发货信息
            </div>
            <el-form-item label="发货类型" v-show="IsHonly == 0">
                <el-radio-group v-model="params.Orders_IsAllFreightValue">
                    <el-radio :label="1">整单发货</el-radio>
                    <el-radio :label="0" v-if="isReturnGoods != 1">分批发货</el-radio>
                </el-radio-group>
            </el-form-item> 
            <el-form-item label="发货方式">
                <el-radio-group v-model="params.Orders_FreightType">
                    <el-radio :label="1">审核订单后发货</el-radio>
                    <el-radio v-if="submitpaymentObj.id != 2" :label="0">即时发货</el-radio>
                </el-radio-group>
                <el-checkbox-group v-model="params.Orders_IsAllReach">
                    <el-checkbox :label="1" :true-label="1" :false-label="0" name="type">
                        <span>所有货物必须一次性发货</span>
                        <span class="tip">一次发货需待所有货物备齐后统一发货，发货周期可能会延长</span>
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="交货时间" v-show="IsHonly == 0">
                <el-input class="el-select-medium"  autocomplete="on" name="Orders_DeliveryTime" v-model="params.Orders_DeliveryTime" placeholder="请输入交货时间"></el-input>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <el-form-item label="期望交货时间">
                <el-date-picker :picker-options="pickerOptions" class="el-select-medium" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="params.Orders_PlanDeliveryDate"></el-date-picker>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <el-form-item label="合同其他约定" v-if="isReturnGoods != 1">
                <el-checkbox-group v-model="params.Orders_OtherAgreementIDArr">
                    <el-checkbox 
                        v-for="item in OtherAgreements" 
                        :label="item.Name" 
                        :key="item.ID"
                        :checked="item.Checkbox === 'True'">
                        {{ item.Name }}
                    </el-checkbox>
                </el-checkbox-group>
                <el-input class="el-select-medium" v-model="params.Orders_OtherAgreementText" :maxlength="100" placeholder="最多不超过100个字符"></el-input>
            </el-form-item>
            <el-form-item label="合同备注">
                <el-input class="el-select-medium"  autocomplete="on" name="order_note" v-model="params.order_note" :maxlength="24" placeholder="最多不超过42个字符"></el-input>
            </el-form-item>
            <el-form-item label="项目类型" v-if="Orders_SourceCate != 1 && isShowProjectType">
                <el-radio-group v-model="params.SPCOrdersProjectTypeId">
                    <el-radio :label="1">新建项目</el-radio>
                    <el-radio :label="2">已建项目(升级改造)</el-radio>
                </el-radio-group>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                采购清单
            </div>
            <div v-if="Orders_SourceCate == 2">
                <div class="cart-list-container" v-if="cartList && cartList.length > 0">
                    <div class="cart-list" v-for="(item, index) in cartList" :key="index">
                        <div class="flex">
                            <div class="cart-top-title-big mr10">
                                <span class="title-contetn">{{ item.DiscountCateName }}</span>
                            </div>
                            <div class="cart-top" v-if="item.DiscountShow && isReturnGoods != 1">
                                <div class="flex">
                                    <el-input v-model="item.inputValue" class="el-select-medium mr10" type="number" placeholder="填写折扣率" />
                                    <el-button type="primary" @click="userComputer1()">计算</el-button>
                                    <div class="MinClass">
                                        <span class="tip">
                                            若输入8，则为价格的8%（折扣率0.08）
                                            <span v-if="item.MinDiscount">
                                                (
                                                <span style="color: #ff3040">最低折扣{{ (item.MinDiscount * 10) | formatePrice3 }}折</span>
                                                )
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="items in item.List" :key="items.ID">
                            <div class="" v-if="isReturnGoods != 1">
                                <div class="cart-top-title-big" v-if="items.DiscountCateName">
                                    <span>{{ items.DiscountCateName || '--' }}</span>
                                </div>
                                <div class="cart-top flex" v-if="items.DiscountShow">
                                    <div class="flex">
                                        <div class="cart-top-title flex">
                                            <div class="title-contetn ellipsis">订单折扣</div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="inputStyle" style="width: 150rpx">
                                            <el-input v-model="items.inputValue" type="number" placeholder="填写折扣率" />
                                        </div>
                                        <el-button type="primary" @click="userComputer1()">计算</el-button>
                                        <div class="MinClass">
                                            <span class="tip">
                                                若输入8，则为价格的8%（折扣率0.08）
                                                <span v-if="items.MinDiscount">
                                                    (
                                                    <span style="color: #ff3040">最低折扣{{ (items.MinDiscount * 10) | formatePrice3 }}折</span>
                                                    )
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="(items.DiscountShow == true || item.DiscountShow == true) && isReturnGoods != 1">
                                <el-table :data="items.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column align="center" width="50px">
                                        <template v-slot="scope">
                                            <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                    <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                    <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                    <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Product_DefaultDiscountPrice" label="默认折扣价" align="center" show-overflow-tooltip width="120">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_DefaultDiscountPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_IsInsale" label="调整折扣价" align="center" width="140">
                                        <template v-slot="scope">
                                            <el-input v-model="scope.row.Goods_Product_AdjustDiscountPrice" type="number" @blur="userComputer1()"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>

                                    <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div v-else>
                                <el-table :data="items.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                    <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                    <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                    <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Product_DefaultDiscountPrice" label="默认折扣价" align="center" show-overflow-tooltip width="120">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_DefaultDiscountPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="Goods_IsInsale"  label="调整折扣价" align="center" width="140">
                                        <template v-slot="scope">
                                            <el-input v-model="scope.row.Goods_Product_AdjustDiscountPrice"
                                                type="number" @blur="userComputer1()"></el-input>
                                        </template>
                                    </el-table-column> -->
                                    <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                                    <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="total" v-if="(item.DiscountShow == true || item.List.some((items) => items.DiscountShow == true)) && isReturnGoods != 1">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                        <div class="total" v-else>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                        </div>
                    </div>
                </div>
                <div class="cart-list-container mt20" v-if="activityCartList && activityCartList.length > 0">
                    <div class="form-title" style="margin-top: 0">
                        <svg-icon icon-class="lm" class-name="lm-icon" />
                        促销商品
                    </div>
                    <div class="cart-list" v-for="(item, index) in activityCartList" :key="index">
                        <div v-for="items in item.List" :key="items.ID">
                            <div>
                                <div class="cart-top-title-big mr10">
                                    <span class="title-contetn">{{ item.DiscountCateName }}</span>
                                </div>
                                <el-table :data="items.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column align="center" width="50px">
                                        <template v-slot="scope">
                                            <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                    <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                    <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                    <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Product_DefaultDiscountPrice" label="默认折扣价" align="center" show-overflow-tooltip width="120">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_DefaultDiscountPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_IsInsale" label="调整折扣价" align="center" width="140">
                                        <template v-slot="scope">
                                            <el-input v-if="scope.row.NoEditPrice != 1" v-model="scope.row.Goods_Product_AdjustDiscountPrice" type="number" @blur="userComputer1()"></el-input>
                                            <div v-else>
                                                {{ scope.row.Goods_Product_AdjustDiscountPrice }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>

                                    <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="total">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                    </div>
                </div>
                <div class="total">
                    商品金额合计:
                    <span>￥{{ Total_Price || 0 }}</span>
                </div>
            </div>
            <div v-else>
                <div class="cart-list-container" v-if="cartList && cartList.length > 0">
                    <div class="cart-list" v-for="(item, index) in cartList" :key="index">
                        <div class="" v-if="isReturnGoods != 1">
                            <div class="flex">
                                <div class="cart-top-title-big mr10">
                                    <span class="title-contetn">{{ item.DiscountCateName || '--' }}</span>
                                </div>
                                <div class="cart-top flex">
                                    <div class="flex">
                                        <div class="cart-top-title flex">
                                            <div class="title-contetn ellipsis">订单折扣</div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="inputStyle" style="width: 150rpx">
                                            <el-input v-model="item.inputValue" :disabled="isReturnGoods == 1" type="number" placeholder="填写折扣率" />
                                        </div>
                                        <el-button type="primary" @click="userComputer()">计算</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <el-table :data="item.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column align="center" width="50px">
                                    <template v-slot="scope">
                                        <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Product_DefaultDiscountPrice" label="默认折扣价" align="center" show-overflow-tooltip width="120">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_DefaultDiscountPrice.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="Orders_Type == 0" prop="Goods_IsInsale" label="调整折扣价" align="center" width="140">
                                    <template v-slot="scope">
                                        <el-input v-if="isReturnGoods != 1" v-model="scope.row.Goods_Product_AdjustDiscountPrice" type="number" @blur="userComputer()"></el-input>
                                        <div class="moneyRed" v-else>{{ scope.row.Goods_Product_AdjustDiscountPrice }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>

                                <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice }}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="total">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                    </div>
                </div>
                <div class="cart-list-container mt20" v-if="activityCartList && activityCartList.length > 0">
                     <div class="form-title" style="margin-top: 0">
                        <svg-icon icon-class="lm" class-name="lm-icon" />
                        促销商品
                    </div>
                    <div class="cart-list" v-for="(item, index) in activityCartList" :key="index">
                        <div>
                            <div class="cart-top-title-big mr10">
                                <span class="title-contetn">{{ item.DiscountCateName }}</span>
                            </div>
                            <el-table :data="item.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column align="center" width="50px">
                                    <template v-slot="scope">
                                        <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Product_DefaultDiscountPrice" label="默认折扣价" align="center" show-overflow-tooltip width="120">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_DefaultDiscountPrice.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_IsInsale" label="调整折扣价" align="center" width="140">
                                    <template v-slot="scope">
                                        <el-input v-if="scope.row.NoEditPrice != 1" v-model="scope.row.Goods_Product_AdjustDiscountPrice" type="number" @blur="userComputer()"></el-input>
                                        <div v-else>
                                            {{ scope.row.Goods_Product_AdjustDiscountPrice }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>

                                <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice }}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="total">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                    </div>
                </div>
                <div class="total">
                    商品金额合计:
                    <span>￥{{ Total_Price || 0 }}</span>
                </div>
            </div>
            <el-form-item label="支付方式" v-if="Orders_Type == 1 && Orders_SourceCate == 2 && CheckIsPrePay()">
                <div>
                    <el-radio checked>待付款</el-radio>
                </div>
                <div>
                    <el-radio-group v-model="params.payWayValue" @change="handlePayWayChange">
                        <el-radio v-for="item in payWayList" :key="item.Pay_Way_ID" :label="item.Pay_Way_ID">
                            {{ item.Pay_Way_Name }}
                        </el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'submitSpcOrder',
    props: {
        Customer_info: {
            type: Object,
            default: () => ({})
        },
        submitpaymentObj: {
            type: Object,
            default: () => ({})
        },
        // 商机信息
        PipelineCustomer: {
            type: Object,
            default: () => ({})
        },
        //订单类型: 0销售订单1服务订单
        Orders_Type: {
            type: [Number, String],
            default: 0
        },
        //交易类型:0：正常交易 1报价单2打包订单
        TradeType: {
            type: [Number, String],
            default: 0
        },
        //返货类型:0：正常交易 1返货
        isReturnGoods: {
            type: [Number, String],
            default: 0
        },
        // 1复制，2追加
        changeOrderType: {
            type: [Number, String],
            default: 0
        },
        //合同来源: 0报价单1合同变更2独立合同
        Orders_SourceCate: {
            type: [Number, String],
            default: 2
        },
        // 商品总金额
        Total_Price: {
            type: [Number, String],
            default: 0
        },
        cartList: {
            type: Array,
            default: () => []
        },
        activityCartList: {
            type: Array,
            default: () => []
        },
        SPCApply_Status: {
            type: [Number, String],
            default: 0
        },
        ordersId: {
            type: [Number, String],
            default: -1
        },
        // 是否显示项目类型
        isShowProjectType: {
            type: Boolean,
            default: false
        },
        // 判断是否仅人工费
        IsHonly: {
            type: [Number, String],
            default: 0
        }
    },
    watch: {
        IsHonly: {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal);
                if (newVal == 1) {
                    this.CheckCartIsHonly();
                }
            }
        },
        Customer_info: {
            handler(newVal) {
                if (newVal && newVal.Customer_Type == 1) {
                    // 当客户类型为个人客户时，自动填充联系人信息
                    this.params.Orders_Contract_Name = newVal.Person_Name || '';
                    this.params.Orders_Contract_Mobile = newVal.Person_Mobile || '';
                }
            },
            deep: true,
            immediate: true
        }
    },
    async mounted() {
        this.resultInfoApply_SN = null;
        let Officeadress = [this.GetOfficeStates(), this.GettOfficeCitys()];
        let orderRequests = [this.getProjectTypes({ name: 'one', id: 0 }), this.GetOfficeMemberOption(), this.CabinetSupplier_Select()];
        await Promise.all(Officeadress);
        await Promise.all(orderRequests);
        this.$emit('mountedEnd');
        if (this.Orders_Type == 1) {
            this.params.Orders_IsAllFreightValue = 1;
        }
        this.GetPayWays();
        this.onLoadSearchUser();
        await this.getOrdersOtherAgreementsCheckbox();
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList,
            
            deliveryProvinceList: (state) => state.common.deliveryProvinceList,
            deliveryCityList: (state) => state.common.deliveryCityList,
            deliveryDistrictList: (state) => state.common.deliveryDistrictList,
        }),
        // 检查当前项目类型ID是否在选项列表中
        isValidProjectType() {
            if (!this.params.Orders_ProjectType_ID || this.ProjectTypesList.length === 0) {
                return false;
            }
            return this.ProjectTypesList.some((item) => item.Project_Type_ID === this.params.Orders_ProjectType_ID);
        }
    },
    data() {
        return {
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: '',
                Orders_Address_State: '', // 省
                Orders_Address_City: '', // 市
                Orders_Address_County: '' // 区
            },
            payWayList: [],
            params: {
                Customer_Project_Country: '1', // 项目国家
                Customer_Project_State: '', // 省
                Customer_Project_City: '', // 市
                Customer_Project_County: '', // 区
                Orders_ProjectType_ID: '', // 项目类型
                Orders_ProjectType_ID_Two: '', // 项目类型二
                Orders_ProjectType_ID_Three: '', // 项目类型三
                Customer_Project_NameThree: '', // 工程名称前缀
                Customer_Project_Name: '', // 工程名称
                Customer_Project_NameTwo: '', // 工程名称后缀
                Orders_Contract_Name: '', // 联系人姓名
                Orders_Contract_Mobile: '', // 联系人手机
                Orders_Contract_Email: '', // 联系人邮箱
                Orders_Delivery_ID: 4, // 配送方式
                delivery_name: '', // 其他配送方式
                Orders_Address_Country: '1', // 配送地址国家
                Orders_Address_State: '', // 配送地址省
                Orders_Address_City: '', // 配送地址市
                Orders_Address_County: '', // 配送地址区
                Orders_Address_StreetAddress: '', // 收货地址
                informValur: [], // 短信通知
                Orders_Address_StreetAddress_type: 'Y', // 客户地址
                Orders_Address_Zip: '', // 邮编
                Orders_Address_Name: '', // 收货人姓名
                Orders_Address_Phone_Number: '', // 联系电话
                Orders_Address_Mobile: '', // 手机
                Orders_OfficeManID: '', // 业务员
                Orders_OfficeManCode:'',    //业务员编码
                Orders_OfficeManName: '', // 业务员名称
                CabinetSupplier: '', // 配电柜厂家
                CabinetSupplierName: '', // 配电柜厂家名称
                Orders_IsAllFreightValue: '', // 发货类型
                Orders_FreightType: '', // 发货方式
                Orders_IsAllReach: 0, // 所有货物必须一次性发货
                Orders_DeliveryTime: '', // 交货时间
                Orders_PlanDeliveryDate: new Date().toISOString().split('T')[0], // 期望交货时间
                Orders_OtherAgreement: '', // 合同其它约定
                Orders_OtherAgreementText: '', // 合同其它约定
                Orders_OtherAgreementIDArr: [], // 合同其它约定id数组
                order_note: '', // 订单备注
                SPCOrdersProjectTypeId: '', // 项目类型
                Orders_PaperContractSN: '', // 纸质合同编号
                SPCApply_AdderID: '', // 业务员id
                payWayValue: '',
                payWayName: ''
            },
            PaperContractSNPlace: 'GST-' + new Date().getFullYear() + '-No.',

            cityListopt: [], //工程城市
            districtListopt: [], //工程区县
            cityListAddress: [], //配送城市
            districtListAddress: [], //配送区县
            sitecityList: [], //城市列表
            siteprovinceList: [], //省列表
            ProjectTypesList: [],
            ProjectTypesListTwo: [],
            ProjectTypesListThree: [],

            officeManID: '',
            offinceList: [],
            SupplierList: [],
            historicalAddressList: [], // 历史地址列表
            historicalAddress: '', // 历史地址
            resultInfoApply_SN: '', // 报价单单号
            ProjectTypeRecursion: '', // 项目类型
            pickerOptions: {
                disabledDate(time) {
                    // 禁用今天之前的日期
                    return time.getTime() < Date.now() - 8.64e7; // 8.64e7 是一天的毫秒数
                }
            },
            applyInfo: {},
            OtherAgreements: [],
            SearchUserCustomerInfo: {},
            SearchUserCustomerInfo_list: [],
            selectedContactName: '', // 选择器模式下的联系人选择值
            selectedContactMobile: '', // 选择器模式下的联系人手机
            selectedContactEmail: '' // 选择器模式下的联系人邮箱
        };
    },
    methods: {
        // 处理联系人选择变化
        handleContactChange(selectedName) {
            const selectedContact = this.SearchUserCustomerInfo_list.find(item => item.name === selectedName);
            if (selectedContact) {
                // 更新显示值
                this.selectedContactMobile = selectedContact.mobile;
                this.selectedContactEmail = selectedContact.email;
                // 更新params值
                this.params.Orders_Contract_Name = selectedContact.name;
                this.params.Orders_Contract_Mobile = selectedContact.mobile;
                this.params.Orders_Contract_Email = selectedContact.email;
            }
        },
        async onLoadSearchUser() {
            var result = await this.$newsApi.order.getCustomerByID({ CustomerID: this.Customer_info.Customer_ID })
            if (result.data && result.data.Resultcode == 0) {
                this.SearchUserCustomerInfo = result.data.data
            }
            var NameArr = this.SearchUserCustomerInfo.Customer_ContractName.split('|')
            var EmailArr = this.SearchUserCustomerInfo.Customer_Email.split('|')
            var MobileArr = this.SearchUserCustomerInfo.Customer_Mobile.split('|')
            var arr = []
            for (let i = 0; i < NameArr.length; i++) {
                var obj = {}
                obj.name = NameArr[i]
                obj.email = EmailArr[i]
                obj.mobile = MobileArr[i]
                arr.push(obj)
            }
            this.SearchUserCustomerInfo_list = arr;
        },
        // 一键转订单-获取合同详情
        async getSPCApplyByID(e) {
            let applyid = e.apply_id;
            let orderResult;
            // 追加时传入的是合同id
            if (this.changeOrderType == 2) {
                orderResult = await this.$newsApi.order.GetSPCOrdersByID({ ID: applyid });
                applyid = orderResult.data.data.Orders_SPCApplyID;
            }
            let result = await this.$newsApi.order.GetSPCApplyByID({ ID: applyid });
            this.applyInfo = result.data.data;
            console.log('一键转订单result', result);
            this.resultInfoApply_SN = result.data.data.SPCApply_SN;
            this.$emit('update:SPCApply_Status', result.data.data.SPCApply_Status);
            let orderInfo = await this.$newsApi.order.GetSPCOrdersByOrders_SPCApplySN({ Apply_SN: result.data.data.SPCApply_SN, customerID: result.data.data.SPCApply_CustomerID });
            console.log('一键转订单orderInfo', orderInfo);
            this.disposeApplyDetails(orderInfo.data.data, result.data.data);
            await this.getOrdersOtherAgreementsCheckbox();
            
        },
        // 处理项目类型选择变化
        handleProjectTypeChange(value) {
            this.params.Orders_ProjectType_ID = value;
        },
        // 关联报价单-处理工程信息
        async getSPCApplyByID_Project(e) {
            let applyid = e.apply_id;
            let result = await this.$newsApi.order.GetSPCApplyByID({ ID: applyid });
            let orderInfo = await this.$newsApi.order.GetSPCOrdersByOrders_SPCApplySN({ Apply_SN: result.data.data.SPCApply_SN, customerID: result.data.data.SPCApply_CustomerID });
            this.disposeApplyDetails_Project(orderInfo.data.data, result.data.data);
        },
        // 一键转订单-处理详情信息回显
        async disposeApplyDetails(detailsData, SPCApplyData) {
            // 需要根据省筛选出市列表，根据市筛选出县列表，这样才能回显
            this.cityListopt = this.cityList.filter((item) => item.Statecode == detailsData.Orders_ProjectState);
            this.districtListopt = this.districtList.filter((item) => item.citycode == detailsData.Orders_ProjectCity);
            this.cityListAddress = this.sitecityList.filter((item) => item.Statecode == detailsData.Orders_Address_State);
            this.districtListAddress = this.deliveryDistrictList.filter((item) => item.citycode == detailsData.Orders_Address_City);
            // 回显项目类型
            this.DisplayProjectTypeRecursion(SPCApplyData.SPCApply_ProjectType_ID);
            // 短信通知
            if (detailsData.Orders_MsgNotify == 0) {
                this.params.informValur = [1, 2];
            } else if (detailsData.Orders_MsgNotify == -1) {
                this.params.informValur = [];
            } else if (detailsData.Orders_MsgNotify == 1) {
                this.params.informValur = [1];
            } else if (detailsData.Orders_MsgNotify == 2) {
                this.params.informValur = [2];
            }
            // 历史地址
            if (SPCApplyData.SPCApply_SN && this.isReturnGoods != 1) {
                this.GetSPCOrdersHistoryAddrByApplyID(SPCApplyData.SPCApply_SN);
            }
            // 项目名称
            this.params.Customer_Project_Name = SPCApplyData.SPCApply_ProjectName;
            if(SPCApplyData.SPCApply_OfficeManID){
                if(this.offinceList.find((item) => item.ID == SPCApplyData.SPCApply_OfficeManID))
                {
                    this.params.Orders_OfficeManName = this.offinceList.find((item) => item.ID == SPCApplyData.SPCApply_OfficeManID).OwnerName;
                }                
            }
            
            // 映射关系
            const mapping = {
                Orders_Contract_Name: 'Orders_Contract_Name',
                Orders_Contract_Mobile: 'Orders_Contract_Mobile',
                Orders_Contract_Email: 'Orders_Contract_Email',
                Orders_Address_Country: 'Orders_Address_Country',
                Orders_Address_State: 'Orders_Address_State',
                Orders_Address_City: 'Orders_Address_City',
                Orders_Address_County: 'Orders_Address_County',
                Orders_Address_StreetAddress: 'Orders_Address_StreetAddress',
                Orders_Address_StreetAddress_type: 'Orders_Address_Type',
                Orders_Address_Name: 'Orders_Address_Name',
                Orders_Address_Mobile: 'Orders_Address_Mobile',
                Orders_Address_Phone_Number: 'Orders_Address_Phone_Number',
                Orders_Address_Zip: 'Orders_Address_Zip'
            };
            const mappingSPCApply = {
                Customer_Project_Country: 'SPCApply_ProjectCountry',
                Customer_Project_State: 'SPCApply_ProjectState',
                Customer_Project_City: 'SPCApply_ProjectCity',
                Customer_Project_County: 'SPCApply_ProjectCounty',
                Orders_ProjectType_ID: 'SPCApply_ProjectType_ID',
                Orders_OfficeManID: 'SPCApply_OfficeManID',
                Orders_OfficeManCode:'SPCApply_OfficeManCode',
                //Orders_OfficeManName: 'SPCApply_AdderName',
                // Orders_PlanDeliveryDate: 'SPCApply_PlanDeliveryDays',
                SPCApply_AdderID: 'SPCApply_AdderID',
                
                SPCApply_AdderCode: 'SPCApply_AdderCode'
            };
            // 赋值操作
            for (const key in mapping) {
                if (mapping.hasOwnProperty(key) && detailsData[mapping[key]]) {
                    this.params[key] = detailsData[mapping[key]];
                }
            }
         
            for (const key in mappingSPCApply) {
                if (mappingSPCApply.hasOwnProperty(key)) {
                    this.params[key] = SPCApplyData[mappingSPCApply[key]];
                }
            }
            // 让后续业务员列表与报价单业务员保持一致的上下文
            this.officeManID = this.params.Orders_OfficeManID;
            // 使用公共验证方法检查区/县值是否存在于districtListAddress中，如果不存在则清空
            if (!this.isValueExistInOptions(this.params.Orders_Address_County, this.districtListAddress)) {
                this.params.Orders_Address_County = '';
            }
            // if (this.params.Orders_OfficeManCode) {
            //     this.params.Orders_OfficeManName = `[${this.params.Orders_OfficeManCode}]${this.params.Orders_OfficeManName}`;
            // }
            this.params.Orders_Address_StreetAddress_type = this.params.Orders_Address_StreetAddress_type == 'N' ? 'N' : 'Y';
            if (this.isTimeExceeded(this.params.Orders_PlanDeliveryDate)) {
                this.params.Orders_PlanDeliveryDate = new Date().toISOString().split('T')[0];
            }
            let Project_Customer_Project_Site_Name = this.getAddressName(this.params.Customer_Project_Country, this.params.Customer_Project_State, this.params.Customer_Project_City, this.params.Customer_Project_County);
            let DisplayProjectType = await this.$newsApi.order.DisplayProjectTypeRecursion({ ID: SPCApplyData.SPCApply_ProjectType_ID });
            this.ProjectTypeRecursion = Project_Customer_Project_Site_Name + ' ' + DisplayProjectType.data.data;
           
            // 追加合同时，发货类型和发货方式应该显示为空
            if (this.changeOrderType == 2) {
                this.params.Orders_IsAllFreightValue = '';
                this.params.Orders_FreightType = '';
            }

            if (this.isReturnGoods == 1) {
                this.params.Orders_Address_Country = '';
                this.params.Orders_Address_State = '';
                this.params.Orders_Address_City = '';
                this.params.Orders_Address_County = '';
                this.cityListAddress = [];
                this.districtListAddress = [];
                this.params.Orders_IsAllFreightValue = 1;
            }
        },
        // 关联报价单-处理工程信息回显
        async disposeApplyDetails_Project(detailsData, SPCApplyData) {
            // 需要根据省筛选出市列表，根据市筛选出县列表，这样才能回显
            this.cityListopt = this.cityList.filter((item) => item.Statecode == detailsData.Orders_ProjectState);
            this.districtListopt = this.districtList.filter((item) => item.citycode == detailsData.Orders_ProjectCity);
            this.cityListAddress = this.sitecityList.filter((item) => item.Statecode == detailsData.Orders_Address_State);
            this.districtListAddress = this.deliveryDistrictList.filter((item) => item.citycode == detailsData.Orders_Address_City);
            // 回显项目类型
            this.DisplayProjectTypeRecursion(detailsData.Orders_ProjectType_ID);
            // 短信通知
            // const mapping = {
            //     Orders_Address_State: 'Orders_Address_State',
            //     Orders_Address_City: 'Orders_Address_City',
            //     Orders_Address_County: 'Orders_Address_County',
            //     Orders_Address_StreetAddress: 'Orders_Address_StreetAddress',
            //     Orders_Address_StreetAddress_type: 'Orders_Address_Type',
            //     Orders_Address_Name: 'Orders_Address_Name',
            //     Orders_Address_Mobile: 'Orders_Address_Mobile',
            //     Orders_Address_Phone_Number: 'Orders_Address_Phone_Number',
            //     Orders_Address_Zip: 'Orders_Address_Zip'
            // };
            const mappingSPCApply = {
                Customer_Project_Country: 'SPCApply_ProjectCountry',
                Customer_Project_State: 'SPCApply_ProjectState',
                Customer_Project_City: 'SPCApply_ProjectCity',
                Customer_Project_County: 'SPCApply_ProjectCounty',
                Orders_ProjectType_ID: 'SPCApply_ProjectType_ID'
                // Orders_OfficeManID: 'SPCApply_AdderID',
                // Orders_PlanDeliveryDate: 'SPCApply_PlanDeliveryDays',
                // SPCApply_AdderID: 'SPCApply_AdderID'
            };
            // 赋值操作
            // for (const key in mapping) {
            //     if (mapping.hasOwnProperty(key)) {
            //         this.params[key] = detailsData[mapping[key]];
            //     }
            // }
            for (const key in mappingSPCApply) {
                if (mappingSPCApply.hasOwnProperty(key)) {
                    this.params[key] = SPCApplyData[mappingSPCApply[key]];
                }
            }
            // 使用公共验证方法检查区/县值是否存在于districtListAddress中，如果不存在则清空
            // if (!this.isValueExistInOptions(this.params.Orders_Address_County, this.districtListAddress)) {
            //     this.params.Orders_Address_County = '';
            // }
        },
        isTimeExceeded(targetTime) {
            const now = Date.now(); // 获取当前时间戳
            const targetTimeStamp = new Date(targetTime).getTime(); // 获取目标时间戳
            return targetTimeStamp > now;
        },
        // 修改合同-获取合同详情
        async getSPCOrdersDetails(e) {
            let result = await this.$newsApi.order.GetSPCOrdersByID({ ID: e.orders_id });
            console.log('修改合同result', result);
            this.$emit('update:SPCApply_Status', result.data.data.SPCApply_Status);
            this.disposeDetails(result.data.data);
            await this.getOrdersOtherAgreementsCheckbox();
        },
        // 修改合同-处理详情信息回显
        disposeDetails(detailsData) {
            // 需要根据省筛选出市列表，根据市筛选出县列表，这样才能回显
            this.cityListopt = this.cityList.filter((item) => item.Statecode == detailsData.Orders_ProjectState);
            this.districtListopt = this.districtList.filter((item) => item.citycode == detailsData.Orders_ProjectCity);
            this.cityListAddress = this.sitecityList.filter((item) => item.Statecode == detailsData.Orders_Address_State);
            this.districtListAddress = this.deliveryDistrictList.filter((item) => item.citycode == detailsData.Orders_Address_City);
            // 回显项目类型
            this.DisplayProjectTypeRecursion(detailsData.Orders_ProjectType_ID);
            // 历史地址
            if (detailsData.Orders_SPCApplySN && this.changeOrderType != 1 && this.isReturnGoods != 1) {
                this.GetSPCOrdersHistoryAddrByApplyID(detailsData.SPCApply_SN);
            }
            // 短信通知
            if (detailsData.Orders_MsgNotify == 0) {
                this.params.informValur = [1, 2];
            } else if (detailsData.Orders_MsgNotify == -1) {
                this.params.informValur = [];
            } else if (detailsData.Orders_MsgNotify == 1) {
                this.params.informValur = [1];
            } else if (detailsData.Orders_MsgNotify == 2) {
                this.params.informValur = [2];
            }
            // 是否一次性发货
            this.params.Orders_IsAllReach = detailsData.Orders_IsAllReach == 1 ? 1 : 0;
            // 项目名称
            this.params.Customer_Project_Name = detailsData.Extend.Orders_MainProjectName;
            this.params.Customer_Project_NameThree = detailsData.Orders_ProjectName.substring(0, detailsData.Orders_ProjectName.indexOf(detailsData.Extend.Orders_MainProjectName));
            this.params.Customer_Project_NameTwo = detailsData.Orders_ProjectName.substring(detailsData.Orders_ProjectName.indexOf(detailsData.Extend.Orders_MainProjectName) + detailsData.Extend.Orders_MainProjectName.length);
            // 配电柜

            if (detailsData.Extend.Orders_CabinetSupplierID && this.isValueExistInOptions(detailsData.Extend.Orders_CabinetSupplierID, this.SupplierList, 'value')) {
                this.params.CabinetSupplier = detailsData.Extend.Orders_CabinetSupplierID.toString();
            } else {
                this.params.CabinetSupplier = '';
            }

            this.params.CabinetSupplierName = this.SupplierList.find((item) => item.value == detailsData.Extend.Orders_CabinetSupplierID).Name;
            this.params.Orders_OfficeManName = this.offinceList.find((item) => item.ID == detailsData.Orders_OfficeManID).OwnerName;
            // 映射关系
            const mapping = {
                Customer_Project_Country: 'Orders_ProjectCountry',
                Customer_Project_State: 'Orders_ProjectState',
                Customer_Project_City: 'Orders_ProjectCity',
                Customer_Project_County: 'Orders_ProjectCounty',
                Orders_ProjectType_ID: 'Orders_ProjectType_ID',
                Orders_Contract_Name: 'Orders_Contract_Name',
                Orders_Contract_Mobile: 'Orders_Contract_Mobile',
                Orders_Contract_Email: 'Orders_Contract_Email',
                Orders_Delivery_ID: 'Orders_Delivery',
                delivery_name: 'Orders_Delivery_Name',
                Orders_Address_Country: 'Orders_Address_Country',
                Orders_Address_State: 'Orders_Address_State',
                Orders_Address_City: 'Orders_Address_City',
                Orders_Address_County: 'Orders_Address_County',
                Orders_Address_StreetAddress: 'Orders_Address_StreetAddress',
                Orders_Address_StreetAddress_type: 'Orders_Address_Type',
                Orders_Address_Name: 'Orders_Address_Name',
                Orders_Address_Mobile: 'Orders_Address_Mobile',
                Orders_OfficeManID: 'Orders_OfficeManID',
                Orders_FreightType: 'Orders_FreightType',
                Orders_DeliveryTime: 'Orders_DeliveryTime',
                // Orders_PlanDeliveryDate: 'Orders_PlanDeliveryDate',
                Orders_OtherAgreement: 'Orders_OtherAgreement',
                order_note: 'Orders_Note',
                SPCOrdersProjectTypeId: 'Orders_ProjectType',
                Orders_PaperContractSN: 'Orders_PaperContractSN',
                Orders_IsAllFreightValue: 'Orders_IsAllFreight',
                Orders_Address_Zip: 'Orders_Address_Zip',
                Orders_Address_Phone_Number: 'Orders_Address_Phone_Number',
                Orders_PaperContractSN: 'Orders_TMALLSN',
                SPCApply_AdderID: 'Orders_OfficeManID'
            };
            // 赋值操作
            for (const key in mapping) {
                if (mapping.hasOwnProperty(key) && detailsData[mapping[key]] !== undefined && detailsData[mapping[key]] !== null) {
                    this.params[key] = detailsData[mapping[key]];
                }
            }
            // 复制时，发货类型, 发货方式, 项目类型, 交货时间, 合同其他约定, 合同备注默认不复制
            if (this.changeOrderType == 1) {
                this.params.Orders_IsAllFreightValue = '';
                this.params.Orders_FreightType = '';
                //this.params.Orders_DeliveryTime = ''; 20261-12要求复制交货时间
                this.params.Orders_OtherAgreement = '';
                this.params.order_note = '';
                this.params.SPCOrdersProjectTypeId = '';
            }
            // 返货合同,人工合同默认发货类型赋值
            if (this.isReturnGoods == 1 || this.IsHonly == 1) {
                this.params.Orders_IsAllFreightValue = 1;
            }
            if (detailsData.Orders_SPCApplyID && this.changeOrderType != 1) {
                this.$newsApi.order.GetSPCApplyByID({ ID: detailsData.Orders_SPCApplyID }).then(async (result) => {
                    this.resultInfoApply_SN = result.data.data.SPCApply_SN;
                    this.$emit('update:SPCApply_Status', result.data.data.SPCApply_Status);
                    let Project_Customer_Project_Site_Name = this.getAddressName(this.params.Customer_Project_Country, this.params.Customer_Project_State, this.params.Customer_Project_City, this.params.Customer_Project_County);
                    let DisplayProjectType = await this.$newsApi.order.DisplayProjectTypeRecursion({ ID: detailsData.Orders_ProjectType_ID });
                    this.ProjectTypeRecursion = Project_Customer_Project_Site_Name + ' ' + DisplayProjectType.data.data;
                });
            }
        },
        // 项目类型联动展示
        async DisplayProjectTypeRecursion(e) {
            let result;
            result = await this.$newsApi.order.DisplayProjectTypeRecursionID({ ID: e });
            // 工程类型
            result.data = result.data.data;
            if (result.data) {
                var typeArr = result.data.split('>');
                this.params.Orders_ProjectType_ID = +typeArr[0] || '';
                await this.getProjectTypes({ name: 'two', id: typeArr[0] });
                if (typeArr.length < 2) return;
                this.params.Orders_ProjectType_ID_Two = +typeArr[1] || '';
                if (!typeArr[1]) return;
                await this.getProjectTypes({ name: 'three', id: typeArr[1] });
                this.params.Orders_ProjectType_ID_Three = +typeArr[2] || '';
            }
        },
        // 商机展示工程信息,期望交货时间
        async currentDataPipelineList(e) {
            console.log(e);
            this.params.Customer_Project_Name = e.projectName;
            if (e.demandDate) {
                this.params.Orders_PlanDeliveryDate = e.demandDate;
                if (Number(e.demandDate.substring(0, e.demandDate.indexOf('-')) <= 1900)) {
                    this.params.Orders_PlanDeliveryDate = '';
                }
            }
            let res = await this.$newsApi.order.DisplayProjectTypeByNameRecursionID({ Project_Name: e.industry2 });
            // 工程类型
            let result = res.data;
            if (result.data) {
                var typeArr = result.data.split('>');
                this.params.Orders_ProjectType_ID = +typeArr[0] || '';
                await this.getProjectTypes({ name: 'two', id: typeArr[0] });
                if (typeArr.length < 2) return;
                this.params.Orders_ProjectType_ID_Two = +typeArr[1] || '';
                if (!typeArr[1]) return;
                await this.getProjectTypes({ name: 'three', id: typeArr[1] });
                this.params.Orders_ProjectType_ID_Three = +typeArr[2] || '';
            }
        },
        // 获取表单参数
        getFormParams() {
            let data = this.params;
            return data;
        },
        // 获取地址和项目类型名称
        getNameMethods() {
            let data = this.params;
            let nameInfo = {};
            nameInfo.Customer_Project_Site_Name = this.getAddressName(data.Customer_Project_Country, data.Customer_Project_State, data.Customer_Project_City, data.Customer_Project_County);
            nameInfo.Orders_ProjectType_Name = this.getProjectTypeName(data.Orders_ProjectType_ID, data.Orders_ProjectType_ID_Two, data.Orders_ProjectType_ID_Three);
            nameInfo.Orders_Address_Site_Name = this.getAddressName(data.Orders_Address_Country, data.Orders_Address_State, data.Orders_Address_City, data.Orders_Address_County);
            return nameInfo;
        },
        // 根据工程地址code获取地址名称
        getAddressName(country, state, city, county) {
            let stateItem = this.provinceList.find((item) => item.Code == state);
            let cityItem = this.cityList.find((item) => item.Code == city);
            let countyItem = this.districtList.find((item) => item.Code == county);
            
            let Customer_Project_State_Name = stateItem ? stateItem.Name || '' : '';
            let Customer_Project_City_Name = cityItem ? cityItem.Name || '' : '';
            let Customer_Project_County_Name = countyItem ? countyItem.Name || '' : '';
            let Customer_Project_Site_Name = Customer_Project_State_Name + Customer_Project_City_Name + Customer_Project_County_Name;
            return Customer_Project_Site_Name;
        },
        // 根据项目类型获取项目类型名称
        getProjectTypeName(id, idTwo, idThree) {
            // 防御性检查：确保数组已加载且不为空
            let Orders_ProjectType_Name = '';
            let Orders_ProjectType_Name_Two = '';
            let Orders_ProjectType_Name_Three = '';
            
            // 一级分类
            if (id && this.ProjectTypesList && this.ProjectTypesList.length > 0) {
                const item = this.ProjectTypesList.find((item) => item.Project_Type_ID == id);
                Orders_ProjectType_Name = item ? item.Project_Type_Name || '' : '';
            }
            
            // 二级分类
            if (idTwo && this.ProjectTypesListTwo && this.ProjectTypesListTwo.length > 0) {
                const item = this.ProjectTypesListTwo.find((item) => item.Project_Type_ID == idTwo);
                Orders_ProjectType_Name_Two = item ? item.Project_Type_Name || '' : '';
            }
            
            // 三级分类
            if (idThree && this.ProjectTypesListThree && this.ProjectTypesListThree.length > 0) {
                const item = this.ProjectTypesListThree.find((item) => item.Project_Type_ID == idThree);
                Orders_ProjectType_Name_Three = item ? item.Project_Type_Name || '' : '';
            }
            
            let Orders_ProjectType_info = Orders_ProjectType_Name + Orders_ProjectType_Name_Two + Orders_ProjectType_Name_Three;
            return Orders_ProjectType_info;
        },
        submitOrder() {
            // Handle order submission logic here
            console.log('Order submitted:', this.orderName, this.orderDetails);
        },
        /*
        选择省-工程
        */
        provinceChange(e) {
            this.cityListopt = [];
            this.params.Customer_Project_City = '';
            this.districtListopt = [];
            this.params.Customer_Project_County = '';
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);

            // 验证当前选择的省是否在选项列表中
            if (!this.isValueExistInOptions(e, this.provinceList)) {
                this.params.Customer_Project_State = '';
            }
        },
        /*
        选择市-工程
        */
        cityChange(e) {
            this.districtListopt = [];
            this.params.Customer_Project_County = '';
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);

            // 验证当前选择的市是否在选项列表中
            if (!this.isValueExistInOptions(e, this.cityListopt)) {
                this.params.Customer_Project_City = '';
            }
        },
        /*
        选择省-配送
        */
        provinceChangeAddress(e) {
            this.cityListAddress = [];
            this.params.Orders_Address_City = '';
            this.districtListAddress = [];
            this.params.Orders_Address_County = '';
            this.cityListAddress = this.sitecityList.filter((item) => item.Statecode == e);

            // 验证当前选择的省是否在选项列表中
            if (!this.isValueExistInOptions(e, this.siteprovinceList)) {
                this.params.Orders_Address_State = '';
            }
        },
        /*
        选择市-配送
        */
        cityChangeAddress(e) {
            this.districtListAddress = [];
            this.params.Orders_Address_County = '';
            this.districtListAddress = this.deliveryDistrictList.filter((item) => item.citycode == e);

            // 验证当前选择的市是否在选项列表中
            if (!this.isValueExistInOptions(e, this.cityListAddress)) {
                this.params.Orders_Address_City = '';
            }
        },
        // 获取项目类型
        async getProjectTypes(e) {
            var result = await this.$newsApi.order.getProjectTypes({
                CateID: e.id
            });
            if (e.name == 'one') {
                this.ProjectTypesList = result.data.data || [];
            } else if (e.name == 'two') {
                this.ProjectTypesListTwo = result.data.data || [];
                if (this.ProjectTypesListTwo.length == 0) {
                    this.params.Orders_ProjectType_ID_Two = '';
                }
            } else if (e.name == 'three') {
                this.ProjectTypesListThree = result.data.data || [];
                if (this.ProjectTypesListThree.length == 0) {
                    this.params.Orders_ProjectType_ID_Three = '';
                }
            }
        },
        // 查询订单联系人信息
        async searchUser() {
            if (this.params.Orders_Contract_Name) {
                var result = await this.GetOrdersContractInfo(this.params.Orders_Contract_Name);
                if (result.data) {
                    this.params.Orders_Contract_Mobile = result.data.Member_Mobile;
                    this.params.Orders_Contract_Email = result.data.Member_Email;
                } else {
                    this.$message.error('未查询到该联系人信息');
                    this.params.Orders_Contract_Mobile = '';
                    this.params.Orders_Contract_Email = '';
                }
            } else {
                this.$message.warning('请输入联系人姓名');
                this.params.Orders_Contract_Mobile = '';
                this.params.Orders_Contract_Email = '';
            }
        },
        async GetOrdersContractInfo(e) {
            var result = await this.$newsApi.order.getOrdersContractInfo({
                CustomerID: this.Customer_info.Customer_ID,
                contract_name: e
            });
            return result.data;
        },
        // 公共select选择
        publicSelectChange(e, details) {
            if (e == 'office') {
                this.params.Orders_OfficeManID = details;
                this.params.Orders_OfficeManName = this.offinceList.find((item) => item.ID == details).OwnerName;
            } else if (e == 'cabinet') {
                this.params.CabinetSupplierName = this.SupplierList.find((item) => item.value == details).Name;
            }
        },
        // 报价单业务员选择
        async GetOfficeMemberOption() {
            var result = await this.$newsApi.order.getOfficeMemberOption({ UserID: this.officeManID || this.$store.state.user.userId });
            for (let i = 0; i < result.data.data.length; i++) {
                result.data.data[i].OwnerName = '[' + result.data.data[i].UserCode + ']' + result.data.data[i].OwnerName;
                if (result.data.data[i].ID == this.params.Orders_OfficeManID) {
                    this.params.Orders_OfficeManName = result.data.data[i].OwnerName;
                }
            }
            this.offinceList = result.data.data;
            // 当未有预设业务员ID时，使用默认(IsCheck)项；否则保持已有ID并同步名称
            if (!this.params.Orders_OfficeManID) {
                const checkedItem = this.offinceList.find((item) => item.IsCheck == 'True');
                if (checkedItem) {
                    this.params.Orders_OfficeManID = checkedItem.ID;
                    this.params.Orders_OfficeManName = checkedItem.OwnerName;
                }
            } else {
                const preset = this.offinceList.find((item) => item.ID == this.params.Orders_OfficeManID);
                if (preset) {
                    this.params.Orders_OfficeManName = preset.OwnerName;
                }
            }
        },
        // 配电柜厂家
        async CabinetSupplier_Select() {
            var result = await this.$newsApi.order.CabinetSupplier_Select({ CabinetSupplier_Name: '' });
            if (result.data.data) {
                var arr = [];
                this.SupplierList = [{ Name: '未选择', value: '' }];
                for (var key in result.data.data) {
                    var obj = {};
                    obj.Name = result.data.data[key];
                    obj.value = key;
                    arr.push(obj);
                }
                var data = arr.reverse();
                this.SupplierList = this.SupplierList.concat(data);
            }
        },
        // 计算折扣 销售合同 打包订单
        userComputer() {
            var obj = {};
            var list = this.cartList.concat(this.activityCartList);
            for (let i = 0; i < list.length; i++) {
                // 只有 cartList 中的商品才设置折扣率，activityCartList（促销商品）不设置
                if (i < this.cartList.length) {
                    obj['discountrate_' + list[i].DiscountCateID] = list[i].inputValue; //订单折扣
                }
                var cartId = [];
                for (let j = 0; j < list[i].Goods.length; j++) {
                    if (list[i].Goods[j].checked) {
                        cartId.push(list[i].Goods[j].Goods_ID);
                    }
                    if (i < this.cartList.length) {
                        obj['discountgoods_' + list[i].DiscountCateID] = cartId.join(); //选中的商品
                    }
                    obj['discountprice_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].Goods_Product_AdjustDiscountPrice; //选中的商品
                }
            }
            this.$emit('userComputer', obj);
        },
        // 计算折扣 销售合同
        userComputer1() {
            var obj = {};
            var list = this.cartList.concat(this.activityCartList);
            for (let i = 0; i < list.length; i++) {
                if (list[i].DiscountShow) {
                    if (i < this.cartList.length) {
                        obj['discountrate_' + list[i].DiscountCateID] = list[i].inputValue; //订单折扣
                    }
                }
                for (let k = 0; k < list[i].List.length; k++) {
                    if (list[i].List[k].DiscountShow) {
                        if (i < this.cartList.length) {
                            obj['discountrate_' + list[i].List[k].DiscountCateID] = list[i].List[k].inputValue; //分类折扣
                        }
                    }
                    var cartId = [];
                    for (let j = 0; j < list[i].List[k].Goods.length; j++) {
                        if (list[i].List[k].Goods[j].checked) {
                            cartId.push(list[i].List[k].Goods[j].Goods_ID);
                        }
                        if (list[i].DiscountShow) {
                            if (i < this.cartList.length) {
                                obj['discountgoods_' + list[i].DiscountCateID] = cartId.join(); //选中的商品
                            }
                        } else {
                            if (i < this.cartList.length) {
                                obj['discountgoods_' + list[i].List[k].DiscountCateID] = cartId.join(); //选中的商品
                            }
                        }
                        obj['discountprice_' + list[i].List[k].Goods[j].Goods_ID] = list[i].List[k].Goods[j].Goods_Product_AdjustDiscountPrice; //选中的商品
                    }
                }
            }
            this.$emit('userComputer1', obj);
        },
        // 获取配送省
        async GetOfficeStates() {
            this.siteprovinceList = JSON.parse(JSON.stringify(this.deliveryProvinceList));
            if(this.isReturnGoods == 1 ){
                let res = await this.$newsApi.order.GetOfficeStates({isdelivery:1});
                this.siteprovinceList = res.data.data;
            }
            console.log(this.siteprovinceList, '配送省');
        },
        // 获取配送市
        async GettOfficeCitys() {
            this.sitecityList = JSON.parse(JSON.stringify(this.deliveryCityList));
            if(this.isReturnGoods == 1 ){
                let res = await this.$newsApi.order.GettOfficeCitys({isdelivery:1});
                this.sitecityList = res.data.data;
            }
        },
        // 项目历史地址
        async GetSPCOrdersHistoryAddrByApplyID(e) {
            let res = await this.$newsApi.order.GetSPCOrdersHistoryAddrByApplyID({
                SPCApply_SN: e,
                OrdersID: this.Customer_info.Apply_ID
            });
            this.historicalAddressList = [];
            if (res.data.data) {
                this.historicalAddressList = res.data.data;
                this.historicalAddressList.push({ ShowMessage: '其他' });
                this.historicalAddress = this.historicalAddressList[0].ShowMessage;
            }
        },
        // 项目历史地址
        historicalPickConfirm(e) {
            let selectedItem = this.historicalAddressList.find((item) => item.ShowMessage == e);
            if (selectedItem.ShowMessage != '其他') {
                this.addressFeedback(2, selectedItem);
            }
        },
        countryChange(e, i) {
            if (e == 2) {
                this.params.Orders_Address_Country = i;
                this.params.Orders_Address_State = '';
                this.params.Orders_Address_City = '';
                this.params.Orders_Address_County = '';
                this.districtListAddress = [];
                this.cityListAddress = [];
            } else {
                this.params.Customer_Project_Country = i;
                this.params.Customer_Project_State = '';
                this.params.Customer_Project_City = '';
                this.params.Customer_Project_County = '';
                this.districtListopt = [];
                this.cityListopt = [];
            }
        },
        // 地址
        async GetBranchOfficeByID() {
            let res = await this.$newsApi.order.GetBranchOfficeByID({});
            this.addressFeedback(1, res.data.data);
            let data = {
                AddressCountry: this.Customer_info.Customer_Country,
                AddressState: this.Customer_info.Customer_State,
                AddressCity: this.Customer_info.Customer_City,
                AddressCounty: this.Customer_info.Customer_County,
                AddressStreetAddress: ''
            };
            this.addressFeedback(2, data);
        },
        // 地址验证方法
        isValueExistInOptions(value, optionsList, codeField = 'Code') {
            if (!value || !optionsList || !Array.isArray(optionsList)) {
                return false;
            }
            return optionsList.some((item) => item[codeField] == value);
        },

        // 地址回显
        async addressFeedback(e, res) {
            if (e == 1) {
                if(this.PipelineCustomer && this.PipelineCustomer.ID > 0){
                    this.params.Customer_Project_Country = "1";
                    this.params.Orders_ProjectAddress = this.PipelineCustomer.address;
                    let countyinfo = await this.$newsApi.order.getSysCountyCode({
                        statecode: this.PipelineCustomer.province,
                        countryCode: this.PipelineCustomer.area,
                        citycode: this.PipelineCustomer.city    
                    });
                    countyinfo = this.districtList.find((item) => item.Code == countyinfo.data.data);
                    if(countyinfo){
                        this.params.Customer_Project_County = countyinfo.Code;
                        this.params.Customer_Project_City = countyinfo.citycode;
                    }
                    if(countyinfo.citycode){
                        let cityinfo = this.cityList.find((item) => item.Code == countyinfo.citycode);
                        if(cityinfo){
                            this.params.Customer_Project_State = cityinfo.Statecode;

                        }
                    }
                    this.cityListopt = this.sitecityList.filter((item) => item.Statecode == this.params.Customer_Project_State);
                    this.districtListopt = this.districtList.filter((item) => item.citycode == this.params.Customer_Project_City);
                }else{
                    this.cityListopt = this.cityList.filter((item) => item.Statecode == res.State);
                    this.districtListopt = this.districtList.filter((item) => item.citycode == res.City);
                    this.params.Customer_Project_Country = res.Country;
                    this.params.Customer_Project_State = res.State;
                    this.params.Customer_Project_City = res.City;
                    // this.params.Customer_Project_County = res.County;
                }

                // 使用公共验证方法验证工程地址
                if (!this.isValueExistInOptions(this.params.Customer_Project_State, this.provinceList)) {
                    this.params.Customer_Project_State = '';
                }
                if (!this.isValueExistInOptions(this.params.Customer_Project_City, this.cityListopt)) {
                    this.params.Customer_Project_City = '';
                }
                if (!this.isValueExistInOptions(this.params.Customer_Project_County, this.districtListopt)) {
                    this.params.Customer_Project_County = '';
                }
            } else {
                this.cityListAddress = this.sitecityList.filter((item) => item.Statecode == res.AddressState);
                this.districtListAddress = this.deliveryDistrictList.filter((item) => item.citycode == res.AddressCity);
                this.params.Orders_Address_Country = res.AddressCountry;
                this.params.Orders_Address_State = res.AddressState;
                this.params.Orders_Address_City = res.AddressCity;
                this.params.Orders_Address_County = res.AddressCounty;
                this.params.Orders_Address_StreetAddress = res.AddressStreetAddress || '';

                // 使用公共验证方法验证配送地址
                if (!this.isValueExistInOptions(this.params.Orders_Address_State, this.siteprovinceList)) {
                    this.params.Orders_Address_State = '';
                }
                if (!this.isValueExistInOptions(this.params.Orders_Address_City, this.cityListAddress)) {
                    this.params.Orders_Address_City = '';
                }
                if (!this.isValueExistInOptions(this.params.Orders_Address_County, this.districtListAddress)) {
                    this.params.Orders_Address_County = '';
                }
            }
        },
        // 支付方式变化处理
        handlePayWayChange(value) {
            if (value && this.payWayList.length > 0) {
                const selectedPayWay = this.payWayList.find((item) => item.Pay_Way_ID === value);
                this.params.payWayName = selectedPayWay ? selectedPayWay.Pay_Way_Name : '';
            } else {
                this.params.payWayName = '';
            }
        },
        // 获取支付方式
        async GetPayWays() {
            let res = await this.$newsApi.order.getPayWays({ PayWayCod: 1 });
            this.payWayList = res.data.data;
            this.params.payWayValue = 6;
            // 设置默认支付方式名称
            const defaultPayWay = this.payWayList.find((item) => item.Pay_Way_ID === 6);
            this.params.payWayName = defaultPayWay ? defaultPayWay.Pay_Way_Name : '';
        },
        // 获取合同其他约定
        async getOrdersOtherAgreementsCheckbox() {
            let res = await this.$newsApi.order.getOrdersOtherAgreementsCheckbox({remarks: this.params.Orders_OtherAgreement});
               
            // 处理合同其他约定，提取"其他："之后的内容
            if (this.params.Orders_OtherAgreement && this.params.Orders_OtherAgreement.includes('其他：')) {
                const otherIndex = this.params.Orders_OtherAgreement.indexOf('其他：');
                if (otherIndex !== -1) {
                    this.params.Orders_OtherAgreementText = this.params.Orders_OtherAgreement.substring(otherIndex + 3).trim();
                }
            }
            if (res.data.Resultcode == 0) {
                this.OtherAgreements = res.data.data;
            }
        },
        CheckIsPrePay() {
            let result = false;

            switch (this.submitpaymentObj.id) {
                case 1:
                    result = true;
                    break;
                case 7:
                    result = true;
                    break;
                case 11:
                    result = true;
                    break;
            }
            return result;
        },
        CheckCartIsHonly() {
            this.IsHonly = 1;
            this.params.Orders_IsAllFreightValue = 1;
            this.params.Orders_DeliveryTime = '无';
            this.params.Orders_Delivery_ID = 4;
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .lm-icon {
    margin-right: 10px;
}

.mt0 {
    margin-top: 0 !important;
}

.mt10 {
    margin-top: 10px;
}

.ml10 {
    margin-left: 10px;
}

.mr10 {
    margin-right: 10px;
}

.mb10 {
    margin-bottom: 10px;
}

.tip {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
}

.form-title {
    margin: 40px 0 20px 0;
    font-size: 16px;
    font-weight: 700;
}

.flex {
    display: flex;
    align-items: center;
}

.info {
    // width: 600px;

    .info-title {
        font-size: 16px;
        font-weight: 700;
    }

    .info-item {
        display: flex;
        margin: 10px 0;
        font-size: 14px;
        color: #000000;

        .label {
            width: 90px;
        }

        .content {
            flex: 1;
            height: auto;
        }
    }

    .label-middle {
        width: 100px;
    }
}

.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}

.cart-list {
    background-color: #ffffff;
    font-size: 14px;

    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;

        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }

    .cart-top-title-big {
        font-size: 14px;
        font-weight: normal;
        margin-bottom: 10px;
    }
}

.cart-top-title-big {
    .title-contetn {
        font-size: 14px;
        font-weight: bold;
        margin-right: 10px;
    }
}

.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;

    span {
        color: red;
        padding-right: 20px;
    }
}

.moneyRed {
    font-weight: 700;
    color: red;
}
</style>
